import React from "react";
import { PageTitle } from "../style";
import UnderlinedSelector from "../../../Components/Form/Dropdowns/UnderlinedSelector";
import { useAppDispatch, useAppSelector } from "../../../Redux/app/hooks";
import { selectUtil } from "../../../Redux/features/utilsSlice";
import { filter } from "../util";
import { Description } from "../Dashboard/style";
import SmallButton from "../../../Components/Form/Buttons/SmallButton";
import {
  getCourseRegFormDetails,
  selectCourseReg,
} from "../../../Redux/features/CourseRegSlice";
import { registerCourse } from "../../../Apis/Private/courseReg";

const CourseReb = () => {
  const { semesters, sessions } = useAppSelector(selectUtil);
  const { semesterId, registeringCourses, sessionId } =
    useAppSelector(selectCourseReg);
  const dispatch = useAppDispatch();

  const semesterFilter = filter(semesters, "semesterName", "semesterId");
  const sessionFilter = filter(sessions, "sessionName", "sessionId");

  const handleSelect = (name: string, value: string | number) => {
    dispatch(getCourseRegFormDetails({ name, value }));
  };

  return (
    <>
      <PageTitle>Course Registration</PageTitle>
      <Description>Select the right semester to register</Description>
      {/* <Description><BsInfoCircleFill color='gold' size={20}/> Note: Don't play here </Description> */}
      <div className="flex-centered-items flex-wrap">
        <UnderlinedSelector
          dropdownItems={sessionFilter}
          title={`Session`}
          handleDropdownSelect={handleSelect}
          name="sessionId"
          value={sessionId}
        />
        <UnderlinedSelector
          dropdownItems={semesterFilter}
          title={`Semester`}
          handleDropdownSelect={handleSelect}
          name="semesterId"
          value={semesterId}
        />
      </div>
      <SmallButton
        buttonText="Register"
        handleClick={() => registerCourse(semesterId, sessionId)}
        loading={registeringCourses}
      />
    </>
  );
};

export default CourseReb;
